import axios from 'axios';

const getList = params => axios.get('/tipos-notas-entradas', {
  params,
});
const get = id => axios.get(`/tipos-notas-entradas/${id}`, {});

const save = (tipoNotaEntrada) => {
  if (tipoNotaEntrada.id) {
    return axios.put(`/tipos-notas-entradas/${tipoNotaEntrada.id}`, tipoNotaEntrada);
  }
  return axios.post('/tipos-notas-entradas', tipoNotaEntrada);
};

const remover = id => axios.delete(`/tipos-notas-entradas/${id}`);

const updateTipoNotaEntradaPadrao = tipoNotaEntrada => axios.put(`/tipos-notas-entradas/${tipoNotaEntrada.id}/padrao`, tipoNotaEntrada);

const getNotaEntradaDefault = () => axios.get('/tipos-notas-entradas/padrao');

export default {
  getList,
  get,
  save,
  remover,
  updateTipoNotaEntradaPadrao,
  getNotaEntradaDefault,
};
